import { defineStore } from 'pinia'
import { getDataLang } from '../helpers/api'

export interface ILabelsState {
  labels: {
    CAREER_PAGE_DESCRIPTION: string
    CONTACT_PAGE_EMAIL_EVENT: string
    CONTACT_PAGE_EMAIL_EVENT_LABEL: string
    CONTACT_PAGE_EMAIL_FNB: string
    CONTACT_PAGE_EMAIL_FNB_LABEL: string
    CONTACT_PAGE_EMAIL_LABEL: string
    CONTACT_PAGE_EMAIL_RESERVATION: string
    CONTACT_PAGE_EMAIL_RESERVATION_LABEL: string
    CONTACT_PAGE_PHONE_LABEL: string
    CONTACT_PAGE_QUESTION_DESCRIPTION: string
    CONTACT_PAGE_QUESTION_TITLE: string
    CONTACT_PAGE_TITLE: string
    FOOTER_POWERED_BY_LINK: string
    FOOTER_POWERED_BY_TITLE: string
    HOME_ABOUT_DESCRIPTION: string
    HOME_ABOUT_IMAGE_1: string
    HOME_ABOUT_IMAGE_2: string
    HOME_ABOUT_SUBTITLE_1: string
    HOME_ABOUT_TITLE_1: string
    HOME_ABOUT_DESCRIPTION_1: string
    HOME_ABOUT_SUBTITLE: string
    HOME_ABOUT_TITLE: string
    HOME_DEVIDER_IMAGE: string
    HOME_DEVIDER_SUBTITLE: string
    HOME_DEVIDER_TITLE: string
    HOME_FACILITY_BTN_LABEL: string
    HOME_FACILITY_DESCRIPTION: string
    HOME_FACILITY_IMAGE_1: string
    HOME_FACILITY_SUBTITLE: string
    HOME_FACILITY_TITLE: string
    HOME_GALLERY_BTN_LABEL: string
    HOME_GALLERY_SUBTITLE: string
    HOME_GALLERY_TITLE: string
    HOME_LOGO_HOTEL_1: string
    HOME_LOGO_HOTEL_2: string
    HOME_LOGO_HOTEL_3: string
    HOME_LOGO_HOTEL_LINK_1: string
    HOME_LOGO_HOTEL_LINK_2: string
    HOME_LOGO_HOTEL_LINK_3: string
    HOME_NEWS_BTN_LABEL: string
    HOME_NEWS_SUBTITLE: string
    HOME_NEWS_TITLE: string
    HOME_PAGE_SUBTITLE: string
    HOME_PAGE_TITLE: string
    HOME_PROMO_BTN_LABEL: string
    HOME_PROMO_SUBTITLE: string
    HOME_PROMO_TITLE: string
    HOME_ROOM_BTN_LABEL: string
    HOME_ROOM_SUBTITLE: string
    HOME_ROOM_TITLE: string
    HOME_GENERAL_BTN_LABEL: string
    ROOMS_PAGE_BTN_LABEL: string
    ROOMS_PAGE_BTN_DETAIL_LABEL: string
    ROOMS_PAGE_HERO_IMAGE: string
    ROOMS_PAGE_SUBTITLE: string
    ROOMS_PAGE_TITLE: string
    NEWS_PAGE_BTN_VIEW: string
    OFFERS_PAGE_BTN_BOOK: string
    OFFERS_PAGE_BTN_VIEW: string
    OFFERS_PAGE_TITLE: string
  }
}

const DATA = {
  CAREER_PAGE_DESCRIPTION: '',
  CONTACT_PAGE_EMAIL_EVENT: '',
  CONTACT_PAGE_EMAIL_EVENT_LABEL: '',
  CONTACT_PAGE_EMAIL_FNB: '',
  CONTACT_PAGE_EMAIL_FNB_LABEL: '',
  CONTACT_PAGE_EMAIL_LABEL: '',
  CONTACT_PAGE_EMAIL_RESERVATION: '',
  CONTACT_PAGE_EMAIL_RESERVATION_LABEL: '',
  CONTACT_PAGE_PHONE_LABEL: '',
  CONTACT_PAGE_QUESTION_DESCRIPTION: '',
  CONTACT_PAGE_QUESTION_TITLE: '',
  CONTACT_PAGE_TITLE: '',
  FOOTER_POWERED_BY_LINK: '',
  FOOTER_POWERED_BY_TITLE: '',
  HOME_ABOUT_DESCRIPTION: '',
  HOME_ABOUT_IMAGE_1: '',
  HOME_ABOUT_IMAGE_2: '',
  HOME_ABOUT_SUBTITLE_1: '',
  HOME_ABOUT_TITLE_1: '',
  HOME_ABOUT_DESCRIPTION_1: '',
  HOME_DEVIDER_IMAGE: '',
  HOME_DEVIDER_SUBTITLE: '',
  HOME_DEVIDER_TITLE: '',
  HOME_FACILITY_BTN_LABEL: '',
  HOME_FACILITY_DESCRIPTION: '',
  HOME_FACILITY_IMAGE_1: '',
  HOME_FACILITY_SUBTITLE: '',
  HOME_FACILITY_TITLE: '',
  HOME_GALLERY_BTN_LABEL: '',
  HOME_GALLERY_SUBTITLE: '',
  HOME_GALLERY_TITLE: '',
  HOME_LOGO_HOTEL_1: '',
  HOME_LOGO_HOTEL_2: '',
  HOME_LOGO_HOTEL_3: '',
  HOME_LOGO_HOTEL_LINK_1: '',
  HOME_LOGO_HOTEL_LINK_2: '',
  HOME_LOGO_HOTEL_LINK_3: '',
  HOME_NEWS_BTN_LABEL: '',
  HOME_NEWS_SUBTITLE: '',
  HOME_NEWS_TITLE: '',
  HOME_PAGE_SUBTITLE: '',
  HOME_PAGE_TITLE: '',
  HOME_PROMO_BTN_LABEL: '',
  HOME_PROMO_SUBTITLE: '',
  HOME_PROMO_TITLE: '',
  HOME_ROOM_BTN_LABEL: '',
  HOME_GENERAL_BTN_LABEL: '',
  ROOMS_PAGE_BTN_DETAIL_LABEL: '',
  HOME_ROOM_SUBTITLE: '',
  HOME_ROOM_TITLE: '',
  ROOMS_PAGE_BTN_LABEL: '',
  ROOMS_PAGE_BTN_LABEL2: '',
  ROOMS_PAGE_HERO_IMAGE: '',
  ROOMS_PAGE_SUBTITLE: '',
  ROOMS_PAGE_TITLE: '',
  CONTACT_PAGE_QUESTION_BTN_SUBMIT: '',
  NEWS_PAGE_BTN_VIEW: '',
  OFFERS_PAGE_BTN_BOOK: '',
  OFFERS_PAGE_BTN_VIEW: '',
  OFFERS_PAGE_TITLE: '',
}

export const useLabelsStore = defineStore('labels', {
  state: (): ILabelsState => ({
    labels: DATA,
  }),
  getters: {
    getLabels(): ILabelsState['labels'] {
      let tmp = getDataLang(this.labels)
      if (tmp && Array.isArray(tmp) && tmp.length)
        tmp = tmp[0]

      return tmp
    },
  },
  actions: {
    setLabels(data: ILabelsState['labels']) {
      this.labels = data
    },
  },
})
